export const findGroupById = (groups, id) => groups?.find((group) => group.id === id);
